$(document).ready(function() {
    window.ajax_cart = !0;
    jQuery(window).load(function() {
        jQuery(".ttloader").fadeOut("slow")
    })
});
$(window).scroll(function() {
    if ($(this).scrollTop() > 500) {
        $('.top_button').fadeIn(500)
    } else {
        $('.top_button').fadeOut(500)
    }
});
$('.top_button').click(function(event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, 800)
});
$(document).ready(function() {
    $(".user-background").click(function() {
        $(".tm_header-dropdown .my-account").slideToggle(800);
        $('.tm_header-dropdown').toggleClass('active')
    })
});
$(document).ready(function() {
    $(".cart-text_block").click(function() {
        $(".site-header__cart .cart-content.block").slideToggle(800);
        $('.site-header__cart').toggleClass('active')
    })
});
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function() {
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function() {
            $($(this).attr('href')).hide()
        });
        $(this).find('a').click(function(e) {
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return !1
        })
    })
});
$('.quotes-slider.owl-carousel').owlCarousel({
    loop: !1,
    margin: 0,
    nav: !1,
    dots: !1,
    autoplay: !0,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})
$('#blog_slider.owl-carousel').owlCarousel({
    loop: !0,
    nav: !0,
    dots: !1,
    autoplay: !0,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3
        },
        1000: {
            items: 3
        }
    }
})
$('.slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target).find('.owl-item').removeClass('last').eq(event.item.index + event.page.size - 1).addClass('last')
}).owlCarousel({
    loop: !0,
    nav: !0,
    dots: !1,
    rows: 2,
    responsive: {
        0: {
            items: 2
        },
        551: {
            items: 3
        },
        750: {
            items: 5
        },
        1271: {
            items: 6
        }
    }
})

function more_nav() {
    if ($(window).width() >= 1600) {
        var max_elem = 5;
        var items = $('.header-left #SiteNav > li');
        var surplus = items.slice(max_elem, items.length);
        surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
        $('.hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
    } else if ($(window).width() < 1600) {
        var max_elem = 4;
        var items = $('.header-left #SiteNav > li');
        var surplus = items.slice(max_elem, items.length);
        surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
        $('.hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
    } else {
        var max_elem = 4;
        var items = $('.header-left #SiteNav > li');
        var surplus = items.slice(max_elem, items.length);
        surplus.wrapAll('<li class="more-site-nav hiden_menu"><div class="site-nav__dropdown"><ul>');
        $('.hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
    }
}
$(document).ready(function() {
    more_nav()
});
$('.related.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target).find('.owl-item').removeClass('last').eq(event.item.index + event.page.size - 1).addClass('last')
}).owlCarousel({
    loop: !0,
    margin: 10,
    nav: !0,
    dots: !1,
    responsive: {
        0: {
            items: 2
        },
        551: {
            items: 3
        },
        991: {
            items: 4
        }
    }
})
$('.related.slider.owl-carousel').find('.owl-nav').removeClass('disabled');
$('#brand-slider.owl-carousel').owlCarousel({
    loop: !0,
    margin: 10,
    nav: !1,
    dots: !1,
    autoplay: !0,
    responsive: {
        0: {
            items: 2
        },
        551: {
            items: 3
        },
        750: {
            items: 5
        },
        1000: {
            items: 5
        }
    }
})

// JS for fixed the header navigation
function HeadFixTop(){	
	"use strict";
	if (jQuery(document).width() >=320) {		
	var num = 125; //number of pixels before modifying styles
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.site-header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');	
			} else {
				jQuery('.site-header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');		
			}
		});
	}
	else{		
			jQuery(window).bind('scroll', function () {			
				jQuery('.site-header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');					
		});
			jQuery('.site-header-fix').removeClass('sticky-menu');		
			jQuery('.site-header-fix').removeClass('header-style');	
	}
}

jQuery(document).ready(function() {
    "use strict";
    HeadFixTop()
});
jQuery(window).resize(function() {
    "use strict";
    HeadFixTop()
});

$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function() {
        var active, content, links = $(this).find('a');
        active = links.first().addClass('active');
        content = $(active.attr('href'));
        links.not(':first').each(function() {
            $($(this).attr('href')).hide()
        });
        $(this).find('a').click(function(e) {
            active.removeClass('active');
            content.hide();
            active = $(this);
            content = $($(this).attr('href'));
            active.addClass('active');
            content.show();
            return !1
        })
    })
});

function mobileToggleColumn1() {
    if ($(window).width() < 990) {
        $(".side-bar h3.box-heading").append("<span class='mobile_togglemenu'> </span>");
        $(".side-bar h3.box-heading").addClass('toggle');
        $(".side-box .mobile_togglemenu").click(function() {
            $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow')
        })
    } else {
        $(".side-bar h3.box-heading").removeClass('toggle');
        $(".side-bar h3.box-heading").removeClass('active');
        $(".side-box .mobile_togglemenu").remove()
    }
}
$(document).ready(mobileToggleColumn1);

function mobileToggleColumn() {
    if ($(window).width() < 990) {
        $(".site-footer .footer-box h5").append("<span class='mobile_togglemenu'> </span>");
        $(".site-footer .footer-box h5").addClass('toggle');
        $(".footer-box .mobile_togglemenu").click(function() {
            $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow')
        })
    } else {
        $(".site-footer .footer-box h5").removeClass('toggle');
        $(".site-footer .footer-box h5").removeClass('active');
        $(".footer-box .mobile_togglemenu").remove()
    }
}
$(document).ready(mobileToggleColumn);
$(document).ready(function() {
    $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
    $('#MobileNav .mobile_togglecolumn').click(function() {
        $(this).parent().toggleClass('active')
    });
    $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
    $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function() {
        $(this).parent().toggleClass('active')
    })
});

function mobileToggleMenu10() {
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append("<span class='mobile_togglemenu'> </span>");
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function() {
        $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow')
    })
}
$(document).ready(mobileToggleMenu10);

function mobileToggleMenu11() {
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append("<span class='mobile_togglemenu'> </span>");
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function() {
        $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow')
    })
}
$(document).ready(mobileToggleMenu11);

function responsivecolumn() {
    if ($(document).width() <= 990) {
        $('.main-content .page-width.contents .side-bar').insertAfter('.main-content .page-width.contents .main-container')
    }
}
$(document).ready(function() {
    responsivecolumn()
});
$(window).resize(function() {
    responsivecolumn()
});
$(document).ready(function() {
    $(".header-search-btn").click(function() {
        $(".search-header").slideToggle(300);
        $('.header-search-btn').toggleClass('active')
    })
});
$(document).ready(function() {
    $(".currency-block").click(function() {
        $(".currency .currency-menu").slideToggle(500);
        $('.currency').toggleClass('active')
    })
});
$(document).ready(function() {
    $('#thumbnail-carousel').bxSlider({
        mode: 'vertical',
        minSlides: 3,
        moveSlides: 1,
        slideMargin: 22,
        hideControlOnEnd: !0,
        pager: !1,
        auto: !0,
        touchEnabled: !0,
        infiniteLoop: !0,
    })
});
if ($(window).width() > 989) {
    $('.service-block.service_one').insertAfter('.cat_cms .categoryblock.categoryblock-2')
}
if ($(window).width() < 990) {
    $('.header-center').insertBefore('.header-left');
    $('.servicetop-cms').addClass('page-width')
}
jQuery(function($) {
    var doAnimations = function() {
        var offset = $(window).scrollTop() + $(window).height(),
            $animatables = $('.animatable');
        if ($animatables.length == 0) {
            $(window).off('scroll', doAnimations)
        }
        $animatables.each(function(i) {
            var $animatable = $(this);
            if (($animatable.offset().top + $animatable.height() - 200) < offset) {
                $animatable.removeClass('animatable').addClass('animated')
            }
        })
    };
    $(window).on('scroll', doAnimations);
    $(window).trigger('scroll')
});

function mobile() {
    "use strict";
    var parallax = document.querySelectorAll(".title-breadcrumbs"),
        speed = 0.42;
    window.onscroll = function() {
        [].slice.call(parallax).forEach(function(el, i) {
            var windowYOffset = window.pageYOffset,
                elBackgrounPos = "50%" + -(windowYOffset * speed) + "px";
            el.style.backgroundPosition = elBackgrounPos
        })
    }
}
jQuery(document).ready(function() {
    "use strict";
    mobile()
});
jQuery(window).resize(function() {
    "use strict";
    mobile()
});
$('.product-slider .tab-slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target).find('.owl-item').removeClass('last').eq(event.item.index + event.page.size - 1).addClass('last')
}).owlCarousel({
    loop: !0,
    nav: !0,
    dots: !1,
    rows: 2,
    responsive: {
        0: {
            items: 2
        },
        551: {
            items: 3
        },
        990: {
            items: 5
        },
        1271: {
            items: 6
        }
    }
})
